import React from "react";

import ConfirmationPage from "subscriptions/ConfirmationPage";

import { nounTeamConfirmationHeading } from "subscriptions/data";

const NounProTeamConfirmation = () => {
    return <ConfirmationPage headingTitle={nounTeamConfirmationHeading} />;
};

export default NounProTeamConfirmation;
